<div class="auth-flow-logo-container">
  <img src="assets/logo/dark/css-logo.svg" alt="CSS Logo" i18n-alt />
</div>

<div class="auth-flow-title">
  {{ authFlowTitle$ | async }}
</div>

<div class="auth-flow-subtext">
  {{ authFlowSubtext$ | async }}
</div>

<div class="d-flex flex-column" [style.gap.rem]="2">
  <div class="d-flex flex-column w-100 gap-4" [formGroup]="formGroup">
    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'email'" i18n>Email</label>
      <app-email-input
        #emailInput
        formControlName="email"
        controlId="email"
        [error]="formSubmitted && formGroup.controls.email.invalid" />
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.email.invalid"
        [errors]="formGroup.controls.email.errors"
        [customErrorMessages]="customErrorMessages.email" />
    </div>

    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'password'" i18n>New Password</label>
      <app-password-input
        formControlName="password"
        controlId="password"
        [error]="formSubmitted && formGroup.controls.password.invalid" />
      <div class="subtext" i18n>
        Must contain 8+ characters, including 1 number, 1 special character, 1 uppercase letter, and 1 lowercase letter
      </div>
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.password.invalid"
        [errors]="formGroup.controls.password.errors"
        [customErrorMessages]="customErrorMessages.password" />
    </div>

    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'confirmPassword'" i18n>Confirm Password</label>
      <app-password-input
        formControlName="confirmPassword"
        controlId="confirmPassword"
        [error]="formSubmitted && formGroup.controls.confirmPassword.invalid"
        (keydown.enter)="confirmMember()" />
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.confirmPassword.invalid"
        [errors]="formGroup.controls.confirmPassword.errors"
        [customErrorMessages]="customErrorMessages.confirmPassword" />
    </div>

    <div class="d-flex flex-column gap-1">
      <div class="eula-container">
        <app-checkbox-input formControlName="eulaAccepted" controlId="eulaAccepted" />
        <span class="non-terms-label" i18n>I accept the </span>
        <span (click)="openEulaModal()" class="terms-label" i18n> Terms and Conditions</span>
      </div>
      <app-form-error
        class="mt-2"
        *ngIf="formSubmitted && formGroup.controls.eulaAccepted.invalid"
        [errors]="formGroup.controls.eulaAccepted.errors"
        [customErrorMessages]="customErrorMessages.eulaAccepted" />
    </div>
  </div>

  <div class="sign-in-button-container">
    <app-button class="w-100" [type]="ButtonTypeEnum.primary" (buttonClick)="confirmMember()" i18n>
      Setup Account
    </app-button>
  </div>
</div>

<div class="support-button-container">
  <span class="support-button" i18n>Having trouble?</span>
  <button class="paddingless-text-button mt-2" (click)="openContactPage()" i18n>Click here for support</button>
</div>
